import { Link } from "react-router-dom";
import { genreList } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";

export default function GenreGrid() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="GENRE"
          title="按题材挑选韩漫"
          desc="从言情到奇幻，从热血到治愈，六大热门题材任你挑，快速找到对味的作品。"
          align="center"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {genreList.map((g) => (
            <Link
              key={g.name}
              to="/tuijian"
              className="group rounded-xl bg-background-200/60 border border-background-300/50 p-5 flex flex-col items-center text-center hover:border-accent-500/60 transition-colors"
            >
              <span className="w-12 h-12 rounded-full bg-primary-100/60 text-primary-500 flex items-center justify-center text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={g.icon}></i>
              </span>
              <h3 className="mt-3 font-heading text-sm text-foreground-950">{g.name}</h3>
              <p className="mt-1 text-[11px] text-foreground-600">{g.count} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}